import { Col, Row } from 'antd';
import { USER_PREFERENCES } from '../../../../../../../contants/common';
import useUserPreference from '../../../../../../../redux/hooks/useUserPreference';
import { formateWithMoment } from '../../../../../../../utilz/dates';
import { useBiddingUserSubmitted } from '../../hooks/useBiddingUserSubmitted';

const HalBiddingLogDetailsCard = ({ bidding = {}, quoteBidders = [] }) => {
  const userDateFormat = useUserPreference(USER_PREFERENCES.DEFAULT_DATE_FORMAT);
  const isBidderUnconfirmed = bidding.status === 'UnConfirmed';
  const userSubmitted = useBiddingUserSubmitted({
    status: bidding.status,
    cost: bidding.convertedCost,
    user: bidding.userSubmitted,
  });

  return (
    <>
      <Row gutter={15} className="flex-nowrap pl-15" justify="start">
        <Col sm={5} data-testid="quote-drawer-bidding-spot-quote">
          <p className="m-0 fw-400 f-12 color-label">Spot Quote Number</p>
          <p className="m-0 fw-500 f-13 color-dark">{bidding.quoteNo || '-'}</p>
        </Col>
        <Col sm={5} data-testid="quote-drawer-bidding-expected-time">
          <p className="m-0 fw-400 f-12 color-label">Expected Time Of Departure</p>
          <p className="m-0 fw-500 f-13 color-dark">
            {bidding.expectedTimeOfDeparture
              ? `${formateWithMoment(
                  bidding.expectedTimeOfDeparture,
                  userDateFormat,
                )} ${quoteBidders.shipDate ? '|' : ''} ${formateWithMoment(
                  bidding.expectedTimeOfDeparture,
                  'hh:mm:ss A',
                )}`
              : '-'}
          </p>
        </Col>
        <Col sm={3} data-testid="quote-drawer-bidding-bid-expiry">
          <p className="m-0 fw-400 f-12 color-label">Bid Expiry Date</p>
          <p className="m-0 fw-500 f-13 color-dark">
            {bidding.bidExpiryDate
              ? `${formateWithMoment(bidding.bidExpiryDate, userDateFormat)} ${
                  bidding.bidExpiryDate ? '|' : ''
                } ${formateWithMoment(bidding.bidExpiryDate, 'hh:mm:ss A')}`
              : '-'}
          </p>
        </Col>
        <Col sm={4} data-testid="quote-drawer-bidding-routing">
          <p className="m-0 fw-400 f-12 color-label">Routing</p>
          <p className="m-0 fw-500 f-13 color-dark">{bidding.routing || '-'}</p>
        </Col>
        <Col sm={3} data-testid="quote-drawer-bidding-bid-comment">
          <p className="m-0 fw-400 f-12 color-label">Bid Comment</p>
          <p className="m-0 fw-500 f-13 color-dark">{bidding.bidComment || '-'}</p>
        </Col>
        <Col sm={3} data-testid="quote-drawer-bidding-created-on">
          <p className="m-0 fw-400 f-12 color-label">Created On</p>
          <p className="m-0 fw-500 f-13 color-dark">
            {bidding.createdOn && !isBidderUnconfirmed
              ? `${formateWithMoment(bidding.createdOn, userDateFormat)} ${
                  bidding.createdOn ? '|' : ''
                } ${formateWithMoment(bidding.createdOn, 'hh:mm:ss A')}`
              : '-'}
          </p>
        </Col>
      </Row>

      <Row gutter={15} className="flex-nowrap pl-15 mt-10" justify="start">
        <Col sm={5} data-testid="quote-drawer-bidding-user-submitted">
          <p className="m-0 fw-400 f-12 color-label">User Submitted</p>
          <p
            className="m-0 fw-500 f-13 color-dark"
            style={{
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {userSubmitted}
          </p>
        </Col>
        <Col sm={5} data-testid="quote-drawer-bidding-promised-delivery-date">
          <p className="m-0 fw-400 f-12 color-label">Estimated Delivery Date</p>
          <p className="m-0 fw-500 f-13 color-dark">
            {bidding.promissedDeliveryDate
              ? `${formateWithMoment(bidding.promissedDeliveryDate, userDateFormat)} ${
                  bidding.promissedDeliveryDate ? '|' : ''
                } ${formateWithMoment(bidding.promissedDeliveryDate, 'hh:mm:ss A')}`
              : '-'}
          </p>
        </Col>
        <Col sm={3} data-testid="quote-drawer-bidding-cuttof-date">
          <p className="m-0 fw-400 f-12 color-label">Cutoff Date</p>
          <p className="m-0 fw-500 f-13 color-dark">
            {bidding.cutoffdate
              ? `${formateWithMoment(bidding.cutoffdate, userDateFormat)} ${
                  bidding.cutoffdate ? '|' : ''
                } ${formateWithMoment(bidding.cutoffdate, 'hh:mm:ss A')}`
              : '-'}
          </p>
        </Col>
      </Row>
    </>
  );
};

export default HalBiddingLogDetailsCard;
